import { FocusEventHandler, FunctionComponent, useState } from "react";

type Props = {
    inputId: string,
    inputName: string,
    inputPLaceholder: string,
    isRequired: boolean,
    inputLabel: string,
    defaultvalue?: string,
};

type State = {
    isError: boolean,
    errorMsg: string,
};

const InputPassword: FunctionComponent<Props> = ({inputId, inputName, inputPLaceholder, isRequired, defaultvalue, inputLabel}) => {
    const [state, setState] = useState({} as State);

    const checkValue = (value: string): State => {
        if (value.length === 0 && isRequired) {
            return {isError: true, errorMsg: "Le titre est obligatoire"};
        };
        return {} as State;
    };

    const blur: FocusEventHandler<HTMLInputElement> = (e) => {
        const target = e.currentTarget;
        const value = target.value;
        const isInvalid = checkValue(value);
        setState(isInvalid);
    };


    return (
        <>
            <label htmlFor={inputId} className="inputHelp">{inputLabel} :</label>
            <input
                type="password"
                id={inputId}
                name={inputName}
                placeholder={inputPLaceholder}
                className={`input ${state.isError ? "invalid" : ""}`}
                required={isRequired || false}
                onBlur={blur}
            />
            {state.isError && <p className="inputError">{state.errorMsg}</p>}
        </>
    );
};

export default InputPassword;